module.exports = __webpack_public_path__ + "img/smartphone.1a5a6cd8.png";